@if (isLoading()) {
  <div class="spinner">
    <mat-spinner [diameter]="150" />
  </div>
}
<div class="global_layout">
  <router-outlet />
</div>
